import useCalApi from "@/components/hooks/useCalApi";
import { useCalendarLink } from "@/components/hooks/useCalendarLink";
import { Button } from "@/components/ui/button";

import type { ReactNode } from "react";
import type { ButtonProps } from "@/components/ui/button";

type CalConfigValue = string | number | boolean;

interface CalBookingButtonProps extends Omit<ButtonProps, "children"> {
  children?: ReactNode;
  calConfig?: Record<string, CalConfigValue>;
}

export function CalBookingButton({ children = "Book a call today", calConfig, ...props }: CalBookingButtonProps) {
  useCalApi();
  const { calPath } = useCalendarLink();
  const serializedConfig = JSON.stringify({
    layout: "month_view",
    ...calConfig,
  });

  return (
    <Button type="button" data-cal-link={calPath} data-cal-config={serializedConfig} {...props}>
      {children}
    </Button>
  );
}
